import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../components/SafeIcon';
import { FiSettings, FiShield, FiDatabase, FiCpu } from 'react-icons/fi';

const Settings = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8 pb-20 md:pb-0 h-full flex flex-col">
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-white mb-2 flex items-center">
          <SafeIcon icon={FiSettings} className="mr-3 text-transit-neon" />
          SYSTEM_CONFIGURATION
        </h1>
        <p className="text-gray-400 font-mono text-sm">Adjust core parameters and view system diagnostics.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 flex-1">
        
        {/* Controls */}
        <div className="space-y-4">
          <div className="bg-asphalt-800 border border-asphalt-600 rounded-lg p-6">
            <h3 className="text-lg font-mono text-amber-500 mb-6 flex items-center border-b border-asphalt-700 pb-2">
              <SafeIcon icon={FiShield} className="mr-2" /> PRIVACY_PROTOCOLS
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-white">Location Masking</p>
                  <p className="text-xs font-mono text-gray-500">Obscure exact coordinates from P2P nodes</p>
                </div>
                <div className="w-12 h-6 bg-transit-600 rounded-full relative cursor-pointer">
                  <motion.div layout className="w-4 h-4 bg-white rounded-full absolute top-1 right-1" />
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-white">Data Telemetry</p>
                  <p className="text-xs font-mono text-gray-500">Share anonymous movement data</p>
                </div>
                <div className="w-12 h-6 bg-asphalt-600 rounded-full relative cursor-pointer">
                  <motion.div layout className="w-4 h-4 bg-gray-400 rounded-full absolute top-1 left-1" />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-asphalt-800 border border-asphalt-600 rounded-lg p-6">
            <h3 className="text-lg font-mono text-transit-neon mb-6 flex items-center border-b border-asphalt-700 pb-2">
              <SafeIcon icon={FiDatabase} className="mr-2" /> CACHE_MANAGEMENT
            </h3>
            <div className="flex items-center justify-between">
              <span className="text-sm font-mono text-gray-400">LOCAL_STORAGE: 2.4GB</span>
              <button className="px-4 py-2 bg-red-500/10 text-red-500 border border-red-500/30 rounded text-xs font-mono hover:bg-red-500 hover:text-white transition-colors">
                PURGE
              </button>
            </div>
          </div>
        </div>

        {/* Diagnostics & Credits */}
        <div className="space-y-4 flex flex-col">
          <div className="bg-asphalt-800 border border-asphalt-600 rounded-lg p-6 flex-1">
            <h3 className="text-lg font-mono text-white mb-6 flex items-center border-b border-asphalt-700 pb-2">
              <SafeIcon icon={FiCpu} className="mr-2" /> DIAGNOSTICS
            </h3>
            <div className="space-y-2 font-mono text-xs text-gray-400">
              <p className="flex justify-between"><span>CORE_VERSION:</span> <span className="text-transit-neon">v1.4.0-beta</span></p>
              <p className="flex justify-between"><span>BUILD_HASH:</span> <span>a3f9b2c</span></p>
              <p className="flex justify-between"><span>LATENCY:</span> <span className="text-green-400">12ms</span></p>
              <p className="flex justify-between"><span>SERVER_NODE:</span> <span>US-EAST-1A</span></p>
              
              <div className="mt-6 p-4 bg-asphalt-900 border border-asphalt-700 rounded text-[10px] leading-relaxed opacity-70">
                <span className="text-amber-500 animate-pulse">_</span> INITIALIZING SUB-ROUTINES...<br/>
                [OK] MODULE_SCANNER LOADED<br/>
                [OK] MAP_API CONNECTED<br/>
                [WARN] P2P_SYNC DELAY DETECTED... RETRYING<br/>
                [OK] SYSTEM STABLE.
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* Mandatory Credit Footer */}
      <footer className="mt-8 pt-4 border-t border-asphalt-700 text-center">
        <p className="text-xs font-mono text-gray-500 tracking-widest uppercase">
          Made by LingLink AI and DigLab AI
        </p>
      </footer>
    </div>
  );
};

export default Settings;